// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { CommunicationSignalingClient } from "@azure/communication-signaling";
export const getSignalingClient = (credential, logger, options) => {
    var _a;
    return new CommunicationSignalingClient(credential, logger, {
        environment: (_a = options === null || options === void 0 ? void 0 : options.environment) !== null && _a !== void 0 ? _a : undefined
    });
};
//# sourceMappingURL=signalingClient.browser.js.map